<template>
    <div>
        <app-sub-title text="Filtros" />
        <!-- -------------- filtro  Asignar peticiones---------->
        <b-row>
            <b-col cols="12" md="4" lg="3" v-if="isAssigned">
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectClient"
                />
            </b-col>
            <b-col cols="12" lg="2" v-if="isAssigned">
                <app-form-text-input
                    v-model="filters.assigned"
                    placeholder="Usuario asignado"
                />
            </b-col>
            <b-col cols="12" md="4" lg="2" v-if="isAssigned">
                <app-form-select-input
                    placeholder="Tipo"
                    :options="types"
                    v-model="filters.type"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="2" v-if="isAssigned">
                <app-form-select-input
                    placeholder="Categoria"
                    :options="categories"
                    v-model="filters.category"
                    @change="onSelectCategory"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" lg="2" v-if="isAssigned">
                <app-form-select-input
                    placeholder="SubCategoria"
                    :options="subCategories"
                    v-model="filters.subCategory"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="2" v-if="isAssigned">
                <app-form-select-input
                    placeholder="Calificación"
                    :options="ratings"
                    v-model="filters.rating"
                >
                </app-form-select-input>
            </b-col>
        </b-row>
        <!-- -------------- filtro peticiones sin Asignar ---------->
        <b-row v-if="isNotAssigned">
            <b-col cols="12" md="4" lg="2">
                <app-form-select-input
                    placeholder="Tipo"
                    :options="types"
                    v-model="filters.type"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="1">
                <b-button
                    variant="primary"
                    class="btn-block"
                    @click="$emit('filter', filters)"
                    ><i class="fa fa-filter"></i
                ></b-button>
            </b-col>
            <b-col cols="12" md="4" lg="1">
                <b-button
                    variant="secondary"
                    class="btn-block"
                    @click="clearFilters"
                    ><i class="fa fa-times-circle"></i
                ></b-button>
            </b-col>
        </b-row>
        <!-- -----------------resolved -------------- -->
        <b-row v-if="isResolved">
            <b-col cols="12" md="4" lg="3">
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectClient"
                />
            </b-col>
            <b-col cols="12" md="4" lg="2" v-if="isResolved">
                <b-button-group>
                    <b-button
                        :variant="
                            filters.slugstatus === 'resuelta'
                                ? 'success'
                                : 'secondary'
                        "
                        @click="setStatus('resuelta')"
                        >Sin aprobar</b-button
                    >
                    <b-button
                        :variant="
                            filters.approved === 1 ? 'success' : 'secondary'
                        "
                        @click="setStatus('approved')"
                        >Aprobadas</b-button
                    >
                </b-button-group>
            </b-col>
            <b-col cols="12" md="4" lg="2" v-if="isResolved">
                <app-form-select-input
                    placeholder="Tipo"
                    :options="types"
                    v-model="filters.type"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="2" v-if="isResolved">
                <app-form-select-input
                    placeholder="Categoria"
                    :options="categories"
                    v-model="filters.category"
                    @change="onSelectCategory"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" lg="2" v-if="isResolved">
                <app-form-select-input
                    placeholder="SubCategoria"
                    :options="subCategories"
                    v-model="filters.subCategory"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="2" v-if="isResolved">
                <app-form-select-input
                    placeholder="Calificación"
                    :options="ratings"
                    v-model="filters.rating"
                >
                </app-form-select-input>
            </b-col>
        </b-row>
        <!-- ----------------------------------------------------- -->
        <b-row v-if="isAssigned">
            <b-col cols="12">
                <app-sub-title text="Fecha de Asignación"></app-sub-title>
            </b-col>
        </b-row>
        <b-row v-if="isAssigned" align-v="end" class="mb-3">
            <b-col cols="12" md="4" lg="2">
                <label for="dateAssignmentFrom">Desde</label>
                <b-form-input
                    type="date"
                    id="dateAssignmentFrom"
                    placeholder="Desde"
                    v-model="filters.dateFrom"
                    :with-time="false"
                />
            </b-col>
            <b-col cols="12" md="4" lg="2">
                <label for="dateAssignmentTo">Hasta</label>
                <b-form-input
                    type="date"
                    id="dateAssignmentTo"
                    placeholder="Hasta"
                    v-model="filters.dateTo"
                    :with-time="false"
                />
            </b-col>
            <b-col cols="12" md="4" lg="1">
                <b-button
                    variant="primary"
                    class="btn-block"
                    @click="$emit('filter', filters)"
                    ><i class="fa fa-filter"></i
                ></b-button>
            </b-col>
            <b-col cols="12" md="4" lg="1">
                <b-button
                    variant="secondary"
                    class="btn-block"
                    @click="clearFilters"
                    ><i class="fa fa-times-circle"></i
                ></b-button>
            </b-col>
        </b-row>

        <!-- .-------------------------------------------------- -->
        <b-row v-if="isResolved">
            <b-col cols="12">
                <app-sub-title text="Fecha de Resolución"></app-sub-title>
            </b-col>
        </b-row>
        <b-row v-if="isResolved" class="mb-3" align-v="end">
            <b-col cols="12" md="4" lg="2">
                <label for="answerDateFrom">Desde</label>
                <b-form-input
                    type="date"
                    id="answerDateFrom"
                    placeholder="Desde"
                    v-model="filters.answerDateFrom"
                    :with-time="false"
                />
            </b-col>
            <b-col cols="12" md="4" lg="2">
                <label for="answerDateTo">Hasta</label>
                <b-form-input
                    type="date"
                    id="answerDateTo"
                    placeholder="Hasta"
                    v-model="filters.answerDateTo"
                    :with-time="false"
                />
            </b-col>
            <b-col cols="12" md="auto" class="d-flex justify-content-end">
                <b-row>
                    <b-col>
                        <b-button
                            variant="primary"
                            class="btn-block"
                            @click="$emit('filter', filters)"
                            ><i class="fa fa-filter"></i
                        ></b-button>
                    </b-col>
                    <b-col>
                        <b-button
                            variant="secondary"
                            class="btn-block"
                            @click="clearFilters"
                            ><i class="fa fa-times-circle"></i
                        ></b-button>
                    </b-col>
                </b-row>
            </b-col>
            <!-- <b-col cols="12" md="4" lg="1">

            </b-col> -->
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import Autocomplete from '../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import DateTimePicker from '../../UI/Controls/DateTimePicker/DateTimePicker.vue'

export default {
    components: {
        // appAutocomplete: Autocomplete,
        appDateTimePicker: DateTimePicker,
    },
    props: {
        isAssigned: {
            type: Boolean,
            default: false,
        },
        isResolved: {
            type: Boolean,
            default: false,
        },
        isNotAssigned: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filters: {
                assigned: '',
                dateFrom: '',
                dateTo: '',
                answerDateFrom: '',
                answerDateTo: '',
                client: '',
                approved: '',
                slugstatus: '',
                type: '',
                category: '',
                subCategory: '',
                rating: '',
                dateType: 'assignation',
            },
            selectClient: '',
            types: [],
            categories: [],
            subCategories: [],
            ratings: [],
            clients: [],
        }
    },
    computed: {
        // ...mapGetters(['clients']),
    },
    watch: {
        selectClient(val) {
            if (!val) {
                this.filters.client = ''
                this.selectClient = ''
            } else {
                this.filters.client = val.id
            }
        },
    },
    methods: {
        async loadClients() {
            const { data } = await repo.get('clients/list')
            this.clients = data
        },
        clearFilters() {
            Object.keys(this.filters).map((key) => (this.filters[key] = ''))
            this.$emit('filter', null)
        },
        setStatus(option) {
            if (option === 'resuelta') {
                this.filters.approved = ''
                this.filters.notApproved = 1
                this.filters.slugstatus = 'resuelta'
            } else if (option === 'approved') {
                this.filters.approved = 1
                this.filters.notApproved = ''
                this.filters.slugstatus = ''
            }
            this.$emit('filter', this.filters)
        },
        async loadPetitionTypes() {
            const { data } = await repo.get(
                'petitions/types',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.types = data
        },
        async loadPetitionCategories() {
            const { data } = await repo.get(
                'petitions/categories',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.categories = data
        },
        async loadPetitionRatings() {
            const { data } = await repo.get(
                'petitions/ratings',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.ratings = data
        },
        async onSelectCategory() {
            if (this.filters.category !== '') {
                const { data } = await repo.get(
                    'petitions/sub-categories',
                    { category: this.filters.category },
                    'Lo sentimos, ha ocurrido un error'
                )
                this.subCategories = data
                this.filters.subCategory = data[0].id
            }
        },
    },
    created() {
        this.loadClients()
        this.loadPetitionTypes()
        this.loadPetitionCategories()
        this.loadPetitionRatings()
    },
}
</script>
